<template>
  <div>
    <AddOrEditTemplate />
    <section class="d-flex justify-content-between align-items-end">
      <b-button class="ml-auto" variant="primary" @click="addClick">
        <feather-icon icon="PlusIcon" />
        {{ $t('generals.add') }}
      </b-button>
      <!-- <div>
        <label for="search">{{ $t("generals.search") }}</label>
        <b-form-input
          id="search"
          v-model="query_params.search"
          @input="searchOffices"
        />
      </div> -->
    </section>
    <b-card class="mt-2">
      <b-table :fields="fields" :items="GET_CONTRACT_TEMPLATES.results">
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
        </template>
        <template #cell(actions)="props">
          <div class="d-flex justify-content-between">
            <b-button
              variant="warning"
              size="sm"
              @click="editTemplate(props.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deleteTemplate(props.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-between flex-wrap mx-2 mb-2">
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap">
            {{ $t('pagination.showing_one_to') }}
          </span>
          <b-form-select
            v-model="query_params.page_size"
            :options="[5, 10, 15]"
            class="mx-1"
            @input="pageSizeChange"
          />
          <span class="text-nowrap"
            >{{ $t('pagination.entries') }} (
            {{ GET_CONTRACT_TEMPLATES.count }} )
          </span>
        </div>
        <div>
          <b-pagination
            :value="1"
            :total-rows="GET_CONTRACT_TEMPLATES.count"
            :per-page="query_params.page_size"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @change="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>

    <TempModal :templateProps="template" @saved="refresh" />
  </div>
</template>

<script>
import { BCard, BTable, BButton, BPagination, BFormSelect } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions, mapGetters } from 'vuex'
import TempModal from './components/tempModal.vue'
import AddOrEditTemplate from './addOrEditTemplate.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BPagination,
    BFormSelect,
    FeatherIcon,
    TempModal,
    AddOrEditTemplate,
  },
  data() {
    return {
      template: null,
      currentPage: 1,
      query_params: {
        search: '',
        page: 1,
        page_size: 10,
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'width-50',
        },
        {
          key: 'title',
          label: 'references.title',
        },
        {
          key: 'actions',
          label: 'references.actions',
          class: 'width-150',
        },
      ],
      timeout: 600,
    }
  },
  computed: {
    ...mapGetters('contracts', ['GET_CONTRACT_TEMPLATES']),
  },
  mounted() {
    this.FETCH_CONTRACT_TEMPLATES()
  },
  methods: {
    ...mapActions('contracts', [
      'FETCH_CONTRACT_TEMPLATES',
      'DELETE_CONTRACT_TEMPLATE',
    ]),
    changePage(value) {
      this.query_params.page = value
      this.refresh()
    },
    pageSizeChange(value) {
      this.query_params.page = 1
      this.query_params.page_size = value
      this.refresh()
    },
    refresh() {
      this.FETCH_CONTRACT_TEMPLATES(this.query_params)
    },
    searchOffices() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refresh()
      }, 600)
    },
    editTemplate(template) {
      this.template = template
      this.$nextTick(() => {
        this.$bvModal.show('temp-modal')
      })
      // this.$router.push({ name: 'contract-template-edit', params: { id } })
    },
    addClick() {
      this.template = null
      this.$nextTick(() => {
        this.$bvModal.show('temp-modal')
      })
      // this.$router.push({ name: 'contract-template-add' })
    },
    deleteTemplate(id) {
      this.$_showAreYouSureModal().then((res) => {
        if (res) {
          this.DELETE_CONTRACT_TEMPLATE(id)
            .then(() => {
              this.$_successToast(this.$t('generals.deleted'))
              this.refresh()
            })
            .catch(() => {
              this.$_errorToast(this.$t('generals.error'))
            })
        }
      })
    },
  },
}
</script>

<style></style>
